/*
 * Global functions - General utilities
 */
/* global global */

// Decode HTML entities in a string
global.decodeHtmlEntities = function (string) {
  var txt = document.createElement('textarea');
  txt.innerHTML = string;
  return txt.value;
};

// Check if array contains a value
global.contains_value = function (arr, val) {
  try {
    return arr.indexOf(val) != -1;
  } catch (e) {
    for (var i = 0; i < arr.length; i++) {
      if (arr[i] == val) {
        return true;
      }
    }
    return false;
  }
};

// Display Hotjar feedback widget if enabled
global.display_feedback_widget = function (res) {
  if (res?.display_feedback_widget && !isNaN(window.hotjarId)) {
    (function (h, o, t, j, a, r) {
      h.hj =
        h.hj ||
        function () {
          (h.hj.q = h.hj.q || []).push(arguments);
        };
      h._hjSettings = { hjid: window.hotjarId, hjsv: 6 };
      a = o.getElementsByTagName('head')[0];
      r = o.createElement('script');
      r.async = 1;
      r.src = t + h._hjSettings.hjid + j + h._hjSettings.hjsv;
      a.appendChild(r);
    })(window, document, 'https://static.hotjar.com/c/hotjar-', '.js?sv=');
  }
};


global.sendSurveystudioMetadata = function (res) {

  const checkInIframe = ()=> {
    try {
      return window.self !== window.top;
    } catch (e) {
      // If accessing window.top throws a security error,
      // it means we are inside a cross-origin iframe.
      return true;
    }
  }

  const isInIframe = checkInIframe();

  if (res.surveystudio){

    if ( isInIframe ) {

      // Extract all widget names
      const widgets = (res.init_state?.renderables || [])
        .map((renderable) => renderable?.surveystudio?.widget_name)
        .filter(Boolean);
        
      // SurveyStudio's iframe. Parent window (SurveyStudio FE) handles the data.
      parent.postMessage(
        {
          type: 'STATUS_RESPONSE',
          status: 'metadata',
          questionnaire_name: res.surveystudio.qx_name,
          questionnaire_version: res.surveystudio.qx_version,
          widgets,
          page_name: res.__pg_context__.page_name,
        },
        '*'
      );
    }


  }

};